__turbopack_context__.v({
  "portal": "ADI8pG_portal",
  "shimmer": "ADI8pG_shimmer",
  "text-bar-sweep": "ADI8pG_text-bar-sweep",
});
